import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'

const WebcamContext = createContext()

export const WebcamProvider = ({ children = null }) => {
  const [image, setImage] = useState(null)
  return <WebcamContext.Provider value={{ image, setImage }}>{children}</WebcamContext.Provider>
}
WebcamProvider.propTypes = {
  children: PropTypes.node,
}

export const WebcamConsumer = WebcamContext.Consumer

export default WebcamContext
